export default {
    acl: {
        are_you_sure: 'آیا به حذف اطلاعات انتخاب شده اطمینان دارید؟',
        delete_role_and_permissions: 'حذف سمت و مجوزها',
        edit: 'ویرایش سطح دسترسی',
        id: 'شناسه',
        menu: {
            create: 'ایجاد سطح دسترسی',
            index: 'سطوح دسترسی',
            list: 'سطح دسترسی'
        },
        permissions: 'لیست مجوز‌ها',
        role: 'سِمَت',
        select_all_permissions: 'انتخاب تمام مجوزها',
        select_all_permissions_in_this_column: 'انتخاب تمام مجوزهای این ستون',
        setting: 'ویرایش / حذف',
        tag: 'برچسب'
    },
    no: 'خیر',
    yes: 'بله'
}


